"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
jQuery(document).ready(function () {
    jQuery(document).on('hide.bs.tab', 'a[data-toggle="tab"][data-toggle-val="true"],a[data-toggle="pill"][data-toggle-val="true"]', function (e) {
        if (e.relatedTarget) {
            var frm = jQuery(e.relatedTarget).closest('form');
            if (frm && !frm.valid()) {
                e.preventDefault();
            }
        }
    });
});
jQuery(document).ready(function () {
    jQuery(document).on('click', '[data-async-dropdown]', function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var jqEl, jqElDd, value, url, jqElLnk;
        return __generator(this, function (_a) {
            jqEl = jQuery(e.target);
            jqElDd = jqEl.next('.dropdown-menu');
            value = jqEl.attr('data-async-loaded');
            url = jqEl.attr('data-async-dropdown');
            if (value || jqElDd.length <= 0) {
                return [2];
            }
            if (jqEl.attr('href')) {
                url = jqEl.attr('href');
            }
            else {
                jqElLnk = jqEl.children('a[href]');
                if (jqEl.length > 0 && jqElLnk.attr('href')) {
                    url = jqElLnk.attr('href');
                }
            }
            dataAsyncLoadHtml(url, jqElDd);
            return [2];
        });
    }); });
});
function loadAsyncPartials() {
    function loadAsyncPartial(jqEl) {
        return __awaiter(this, void 0, void 0, function () {
            var value, url, jqElLnk;
            return __generator(this, function (_a) {
                value = jqEl.attr('data-async-loaded');
                url = jqEl.attr('data-async-partial');
                if (value === "y") {
                    return [2];
                }
                jqElLnk = jqEl.children('a[href]');
                if (jqElLnk.length > 0 && jqElLnk.attr('href')) {
                    url = jqElLnk.attr('href');
                }
                dataAsyncLoadHtml(url, jqEl);
                return [2];
            });
        });
    }
    jQuery('[data-async-partial]').each(function (i, e) {
        loadAsyncPartial(jQuery(e));
    });
}
jQuery(document).ready(function () {
    loadAsyncPartials();
    var insertLoadDelay = 0;
    jQuery(document).on('DOMNodeInserted', function () {
        if (insertLoadDelay) {
            clearTimeout(insertLoadDelay);
        }
        setTimeout(loadAsyncPartials, 100);
    });
});
function dataAsyncLoadHtml(url, element) {
    return __awaiter(this, void 0, void 0, function () {
        var htmlResult, htmlElem, koCtx, scrollBottom, scrollY;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!element || element.length <= 0) {
                        return [2];
                    }
                    else if (!url) {
                        console.warn("Partial HTML element ".concat(element.attr('id'), " not populated because no url was specified."));
                        return [2];
                    }
                    element.attr('data-async-loaded', "y");
                    return [4, jQuery.get(url).promise()];
                case 1:
                    htmlResult = _a.sent();
                    if (!htmlResult || htmlResult.indexOf('<!DOCTYPE') >= 0 || htmlResult.indexOf('<html') >= 0) {
                        console.warn("Partial HTML element ".concat(element.attr('id'), " not populated from ").concat(url, " because it didn't return a result OR returned a full HTML page."));
                        element.html('');
                    }
                    else {
                        htmlElem = element.get()[0];
                        koCtx = htmlElem ? ko.contextFor(htmlElem) : null;
                        element.html(htmlResult);
                        if (koCtx && koCtx.$data) {
                            if (typeof koCtx.$data.reInitFields === "function") {
                                koCtx.$data.reInitFields();
                            }
                            else if (typeof koCtx.$data.initFields === "function") {
                                koCtx.$data.initFields();
                            }
                            ko.cleanNode(htmlElem);
                            ko.applyBindings(koCtx, htmlElem);
                            $('[data-toggle="tooltip"]').tooltip();
                            scrollBottom = document.body.offsetHeight - (window.innerHeight + window.scrollY);
                            if (scrollBottom <= 250) {
                                scrollY = window.scrollY;
                                window.scrollTo(window.scrollX, scrollY - 1);
                                window.scrollTo(window.scrollX, scrollY);
                            }
                        }
                    }
                    return [2];
            }
        });
    });
}
((function ($) {
    var multipleSupport = typeof $('<input/>')[0].multiple !== 'undefined';
    var isIE = /msie/i.test(navigator.userAgent);
    $.fn.customFile = function () {
        var customFileThis = this;
        if (isIE) {
            return customFileThis.each(function () { return this; });
        }
        ;
        return customFileThis.each(function () {
            var customFileElemThis = this;
            var $file = $(customFileElemThis).addClass('custom-file-upload-hidden'), $wrap = $('<div class="file-upload-wrapper">'), $input = $('<input type="text" class="file-upload-input" />'), $button = $('<button type="button" class="file-upload-button"><i class="mdi mdi-paperclip"></i></button>'), $buttonSubmit = $('<button type="submit" class="file-upload-button" data-bind="enable: sendButtonEnabled"><i class="mdi mdi-send"></i></button>');
            var clearFileFn = function () {
                var _a, _b;
                (_b = (_a = $file.wrap('<form>').closest('form')) === null || _a === void 0 ? void 0 : _a.get(0)) === null || _b === void 0 ? void 0 : _b.reset();
                $file.unwrap();
                $file.trigger('change');
                $input.val('');
            };
            $file.css({
                position: 'absolute',
                left: '-9999px'
            });
            if (customFileElemThis.getAttribute('data-sendbutton') == null) {
                $wrap.insertAfter($file)
                    .append($file, $input, $button);
            }
            else {
                $wrap.insertAfter($file)
                    .append($file, $input, $button, $buttonSubmit);
            }
            $file.attr('tabIndex', -1);
            $button.attr('tabIndex', -1);
            $button.click(function () { $file.focus().click(); });
            $file.change(function () {
                var files = [];
                var fileArr, filename;
                if (multipleSupport) {
                    fileArr = $file[0].files;
                    for (var i = 0, len = fileArr.length; i < len; i++) {
                        files.push(fileArr[i].name);
                    }
                    filename = files.join(', ');
                }
                else {
                    filename = $file.val().split('\\').pop();
                }
                $input.val(filename)
                    .attr('title', filename)
                    .focus();
            });
            $input.on({
                blur: function () { $file.trigger('blur'); },
                keydown: function (e) {
                    if (e.which === 13) {
                        if (!isIE) {
                            $file.trigger('click');
                        }
                        return false;
                    }
                    else if (e.which === 8 || e.which === 46) {
                        clearFileFn();
                        return false;
                    }
                    else if (e.which === 9) {
                        return false;
                    }
                    else {
                        return false;
                    }
                }
            });
        });
    };
    if (!multipleSupport && !isIE) {
        $('input.custom-file-upload-hidden').on('change', function () {
            var $this = $(this), uniqId = 'customfile_' + (new Date()).getTime(), $wrap = $this.parent(), $inputs = $wrap.siblings().find('.file-upload-input')
                .filter(function () { return !this.value; }), $file = $('<input type="file" id="' + uniqId + '" name="' + $this.attr('name') + '"/>');
            setTimeout(function () {
                if ($this.val()) {
                    if (!$inputs.length) {
                        $wrap.after($file);
                        $file.customFile();
                    }
                }
                else {
                    $inputs.parent().remove();
                    $wrap.appendTo($wrap.parent());
                    $wrap.find('input').focus();
                }
            }, 1);
        });
    }
})(jQuery));
jQuery(document).ready(function () {
    $('input[type=file]').not('.dz-hidden-input').customFile();
});
jQuery(document).ready(function () {
    jQuery(document).on('submit', 'form', function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var jqForm;
        return __generator(this, function (_a) {
            jqForm = jQuery(e.target);
            jqForm.find('.btn').attr("disabled", "true");
            jqForm.find('fieldset').attr("disabled", "true");
            return [2];
        });
    }); });
});
jQuery(window).on('beforeunload', function () {
    jQuery('.page-loader').addClass('show');
});
